import Swiper, {FreeMode} from "swiper"

export default (el) => {
  const swiperEl = el.querySelector('.js-product-topics')

  new Swiper(swiperEl, {
    modules: [FreeMode],
    slidesPerView: 2.4,
    centerInsufficientSlides: true,
    spaceBetween: 8,
    freeMode: {
      enabled: true,
    },
    breakpoints: {
      1200: {
        slidesPerView: 6,
        spaceBetween: 16,
      }
    },
  })
}
